import React, { useState } from "react";
import PortfolioCard from "./Portfolio/PortfolioCard";
function Projects() {
  const categories = ["All", "Web", "Design"];

  const data = [
    {
      id: 1,
      category: "Web",
      title: "Top Courses Mini Project",
      url: "https://top-courses09.netlify.app/",
      code: "https://github.com/shreyash9806/Full-Stack-Web-Development/tree/master/REACT%20Projects/Project%204",
      image: "./images/A1 (1)",
      description:
        "In this React JS project, we demonstrate how to use the map and filter functions to like or unlike courses based on user selection.",
    },
    {
      id: 2,
      category: "Web",
      title: "Mini ECommerce Website",
      url: "https://symphonious-sunburst-642b69.netlify.app/",
      code:"https://github.com/shreyash9806/Full-Stack-Web-Development/tree/master/REACT%20Projects/Project%207",
      image: "./images/A1 (2)",
      description:
        "This project uses Redux to manage e-commerce state, allowing for efficient addition and removal of items from the cart.",
    },
    {
      id: 3,
      category: "Web",
      title: "Cards Project",
      url: "https://velvety-squirrel-36e44a.netlify.app/",
      code:"https://github.com/shreyash9806/Full-Stack-Web-Development/tree/master/REACT%20Projects/Project%201",
      image: "./images/A1 (3)",
      description:
        "React project where we demonstrate the use of Hooks and its Efficiency.",
    },
    {
      id: 4,
      category: "Web",
      title: "React Router Dom",
      url: "https://warm-lolly-0395ba.netlify.app/",
      code:"https://github.com/shreyash9806/Full-Stack-Web-Development/tree/master/REACT%20Projects/Project%208",
      image: "./images/A1 (4)",
      description:
        "Login/SignUp page and demonstration of React Router Dom In depth",
    },
    {
      id: 5,
      category: "Design",
      title: "Usability Hub Clone",
      url: "https://curious-otter-00129b.netlify.app/",
      code:"https://github.com/shreyash9806/Full-Stack-Web-Development/tree/master/HTML%20CSS%20Projects/Project%203",
      image: "./images/A1 (5)",
      description: "Designer Project using Pure CSS",
    },
  ];

  const [category, setCategory] = useState("All");
  const [projects, setProjects] = useState(data);
  return (
    <div className="pt-[80px]" id="portfolio">
      <div className="text-center mb-[50px]">
        <h1 className="lg:text-4xl text-3xl font-semibold">Portfolio</h1>
        <p className="lg:text-xl">Most Recent Work</p>
      </div>

      <div className=" w-11/12 mx-auto flex justify-center gap-4">
        {categories.map((ele, i) => {
          return (
            <button
              className={`font-semibold transition-all hover:bg-gray-900 hover:text-white 
            duration-500  px-[10px]
            py-[5px] rounded-lg text-xl ${
              category === ele ? "bg-gray-900 text-white" : ""
            } `}
              key={i}
              onClick={() => {
                const arr = data.filter((pro, i) => pro.category === ele);
                setCategory(ele);
                ele === "All" ? setProjects(data) : setProjects(arr);
              }}
            >
              {ele}
            </button>
          );
        })}
      </div>
      <div
        className={`${
          projects.length === 1
            ? "flex mt-[40px] justify-center w-fit mx-auto sm:w-5/12 lg:w-4/12"
            : "mt-[40px] mx-auto grid gap-5 sm:grid-cols-2 md:grid-cols-3 lg:w-10/12"
        } `}
      >
        {projects.map((ele) => {
          return <PortfolioCard components={ele} key={ele.id} />;
        })}
      </div>
    </div>
  );
}

export default Projects;
